import React, { useState } from 'react'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import Colors from 'styles/colors'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { amplitudeLogEvent } from 'helpers/amplitude'

import FormErrorMessage from 'components/atoms/FormErrorMessage'

export default props => {
  const [checked, setChecked] = useState(false)
  const [hasError, setHasError] = useState(false)

  const googleSignUpHandler = () => {
    if (!checked) {
      setHasError(true)
      return
    }
    setHasError(false)
    amplitudeLogEvent('Select Signup', { Type: 'Google' })
    // userAgentからLINE or InstagramのWebviewであるかを判定
    // @see: https://zenn.dev/kecy/articles/f51851e42c4243
    if (
      navigator.userAgent.includes('Line') ||
      navigator.userAgent.includes('Instagram')
    ) {
      alert(
        '外部サービスからGoogleアカウントで新規登録できません。Webブラウザかスペースマーケットのアプリから新規登録してください。',
      )
      return
    }
    window.location.href = props.googleAuthUrl
  }

  return (
    <div className="signup-box__wrapper">
      <StyledTerms>
        <StyledTermsText className="signup-box__notes">
          本サービスのご利用には、
          <a href={wwwUrl('/about/terms')} target="_blank">
            スペースマーケット利用規約
          </a>
          ・
          <a href={wwwUrl('/about/terms_of_space_use')} target="_blank">
            ゲスト規約
          </a>
          ・
          <a href={wwwUrl('/about/privacy')} target="_blank">
            プライバシーポリシー
          </a>
          に同意していただく必要があります。
        </StyledTermsText>
        <CheckboxComponent
          id="checkbox-sns"
          onClick={() => setChecked(prev => !prev)}
          checked={checked}
          name="acceptTermOfService"
        >
          規約に同意する
        </CheckboxComponent>
        {hasError && (
          <FormErrorMessage>規約に同意してください。</FormErrorMessage>
        )}
      </StyledTerms>
      <ul className="signup-box__wrapper-fb signup-box__sns">
        <li>
          <GoogleSignUp onClick={googleSignUpHandler}>
            <GoogleIconWrap>
              <img
                src={imagePath('common/logo-icon-google.svg')}
                width="18"
                alt={i18n.t('page.account.l_00005')}
              />
            </GoogleIconWrap>
            {i18n.t('page.account.l_00005')}
          </GoogleSignUp>
        </li>
      </ul>
      <StyledAnnotation>
        ログイン以外の目的に使われることはありません。
      </StyledAnnotation>
    </div>
  )
}

/** 991pxを境目にSCSSで作られているので自前でmediaQueryを設定しています */
const StyledTerms = styled.div`
  width: 400px;
  margin: 0 auto 24px;
  @media screen and (max-width: 991px) {
    width: 100%;
  }
`
const StyledTermsText = styled.div`
  margin: 0 auto 16px;
`
const StyledAnnotation = styled.p`
  line-height: 1.6;
  text-align: center;
`
const SignUp = styled.a`
  width: 100%;
  height: 100%;
  padding: ${spacing.medium}px;
  padding-left: 42px;
  border-radius: 6px;
  border: 1px solid;
  font-size: ${fontSize.medium}px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  position: relative;
  display: block;
`

const GoogleSignUp = styled(SignUp)`
  background-color: #4285f4;
  border: 1px solid #4285f4;
  border-radius: 6px;
  color: ${Colors.mono.white};
`

const GoogleIconWrap = styled.span`
  padding: 14px;
  display: block;
  background-color: white;
  position: absolute;
  left: 0px;
  top: 0px;
  border-radius: 5px 0 0 5px;
`
const CheckboxComponent = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    display: flex;
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    .ant-checkbox-inner {
      top: 1px;
      width: 20px;
      height: 20px;
      :after {
        top: 50%;
        left: 50%;
        transform: rotate(45deg) scale(0) translate(-50%, -50%);
        transform-origin: top;
      }
      .ant-checkbox-input {
        &:focus {
          border-color: ${Colors.brand.primary.main};
        }
      }
    }
    .ant-checkbox {
      vertical-align: top;
    }
    .ant-checkbox-wrapper + span,
    .ant-checkbox + span {
      line-height: 1.35;
      font-size: 14px;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked {
      &.ant-checkbox-disabled .ant-checkbox-inner:after {
        border-color: ${Colors.mono.white};
      }
      &:after {
        border: none;
      }
      .ant-checkbox-inner {
        &:after {
          -webkit-transition: none;
          transition: none;
          transform: rotate(45deg) scale(1) translate(-50%, -50%);
        }
      }
    }
    &:hover {
      .ant-checkbox-inner,
      .ant-checkbox:hover .ant-checkbox-inner,
      .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: ${Colors.brand.primary.main};
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${Colors.mono.white};
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked .ant-checkbox-inner:after {
      border-color: ${Colors.brand.primary.main};
    }
  }
`
